// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";

export default {
    primary: {
        main: "#860038",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#75757a",
        contrast: "#FFFFFF",
    },
    tertiary: {
        main: "#ecb41f",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#333F48",
        accent: "#F8F9FA",
        accentContrast: "#333F48",
        border: "#6D7878",
        disabled: "#EBEBEB",
        mktg1: "#734098",
        mktg2: "#fdba1e",
        mktg3: "#05bdd9",
        mktg4: "#128e7a",
        mktg5: "#df564b",
        mktg6: "#223a74",
        ui1: "#4c4c4e",
        ui2: "#b0b0b7",
        ui3: "#dddde5",
        ui4: "#f0f0f2",
        ui5: "#2F2F2F",
        ui6: "#df564b",
        ui7: "#818186",
        ui8: "#FEFEFE",
        primary1: "#860038",
        primary2: "#75757a",
        primary3: "#ecb41f",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#333333",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#75757a",
    },
    success: {
        main: "#098b38",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#da002e",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#ffa431",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#08a0d0",
        contrast: "#FFFFFF",
    },
    transparent: {
        main: "transparent",
        contrast: "#424242",
    },
} as xBaseTheme["colors"];
